<template>
<div class="record">
  <div v-for="(item, index) in list" :key="index" class="record-item" @click="edit(item)">
    <div>手机号: {{ item.mobile }}</div>
    <div>公司: {{ item.company }}</div>
    <div>联系人: {{ item.contact_name }}</div>
    <div>联系地址: {{ item.address }}</div>
    <div>意向: {{ item.intention }}</div>
    <div>备注: {{ item.remark }}</div>
  </div>
  <van-popup v-model:show="show" closeable>
    <van-form @submit="onSubmit" style="margin-top: 10vh; width: 80vw;">
      <van-cell-group inset>
        <van-field
          v-model="postForm.company"
          name="公司"
          label="公司"
          placeholder="公司"
        />
        <van-field
          v-model="postForm.contact_name"
          name="联系人"
          label="联系人"
          placeholder="联系人"
        />
        <van-field
          v-model="postForm.address"
          name="地址"
          label="地址"
          placeholder="地址"
        />
        <van-field
          v-model="postForm.intention"
          name="意向"
          label="意向"
          placeholder="意向"
        />
        <van-field
          v-model="postForm.remark"
          name="备注"
          label="备注"
          placeholder="备注"
        />
      </van-cell-group>
      <div style="margin: 16px;">
        <van-button round block type="primary" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
  </van-popup>
</div>
</template>

<script>
import {getDetail, saveDetail} from "../../api/record";
import {Toast} from "vant";

export default {
  name: "record",
  data() {
    return {
      list: [],
      show: false,
      postForm: {}
    }
  },
  created() {
    this.initList()
  },
  methods: {
    edit(row) {
      this.postForm = row
      this.show = true
    },
    initList() {
      getDetail().then((res) => {
        this.list = res.data.data
        console.log('res.....', res)
      })
    },
    onSubmit() {
      this.postForm.expo_contacts_id = this.postForm.id
      saveDetail(this.postForm).then((res) => {
        if (res.data.code == 0) {
          Toast('保存成功')
          this.show = false
          this.initList()
        } else {
          Toast('保存失败')
        }
      })
    }
  }
}
</script>

<style scoped>
.record {
  overflow: auto;
}
.record-item {
  text-align: left;
  width: 90vw;
  background-color: #fff5f7;
  margin: 2vw auto 2vw;
  padding: 1vw;
  border-radius: 2vw;
}
</style>



// WEBPACK FOOTER //
// src/views/order/record.vue